// Copy-to-clipboard handler for the ETP Rich Text "Copyable" layout.
// Writes both text/html and text/plain so rich-text targets (Docs, Word)
// keep formatting, while plain-text targets receive a clean fallback.

const FEEDBACK_MS = 2000;

function htmlToPlainText(node) {
  const clone = node.cloneNode(true);
  clone.querySelectorAll('li').forEach((li) => {
    li.insertAdjacentText('afterbegin', '• ');
    li.insertAdjacentText('beforeend', '\n');
  });
  clone.querySelectorAll('p, h1, h2, h3, h4, h5, h6, br, div').forEach((el) => {
    el.insertAdjacentText('beforeend', '\n');
  });
  return clone.textContent.replace(/\n{3,}/g, '\n\n').trim();
}

async function copyContent(button, content) {
  const html = content.innerHTML;
  const text = htmlToPlainText(content);

  try {
    if (navigator.clipboard && window.ClipboardItem) {
      const item = new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' })
      });
      await navigator.clipboard.write([item]);
      return true;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    console.warn('[ETP text-copy] clipboard write failed.', e);
  }
  return false;
}

export function initTextCopy(scope) {
  const root = scope || document;
  const blocks = new Set();
  if (root.matches && root.matches('.etp-text--copyable')) blocks.add(root);
  root.querySelectorAll('.etp-text--copyable').forEach((el) => blocks.add(el));

  blocks.forEach((block) => {
    if (block.dataset.etpTextCopyReady) return;
    block.dataset.etpTextCopyReady = 'true';

    const button = block.querySelector('.etp-text__copy-button');
    const content = block.querySelector('.etp-text__copy-content');
    if (!button || !content) return;

    let timer = null;

    button.addEventListener('click', async () => {
      const ok = await copyContent(button, content);
      if (!ok) return;

      button.classList.add('is-copied');
      const copiedLabel = button.dataset.labelCopied || 'Copied!';
      button.setAttribute('aria-label', copiedLabel);

      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        button.classList.remove('is-copied');
        const copyLabel = button.dataset.labelCopy || 'Copy text to clipboard';
        button.setAttribute('aria-label', copyLabel);
      }, FEEDBACK_MS);
    });
  });
}
